import { FC, useEffect, useState } from 'react';
import _ from 'lodash';
import Joyride, { ACTIONS, CallBackProps, EVENTS } from 'react-joyride';
import ReactHtmlParser from 'react-html-parser';
import { createUsersDemos } from 'common/api/siteTourDemo';
// import tempDataJson from './createStrategySiteTour.json';

type SiteTourProps = {
  id: number;
  steps: {
    content: string;
    target: string;
    title: string;
    disableBeacon?: boolean;
    clickable?: boolean;
  }[];
};

const SiteTour: FC<SiteTourProps> = (props) => {
  const { id, steps } = props;

  // Uncommnet this for testing with static data
  // const steps = tempDataJson as SiteTourProps['steps'];
  // const id = 7;

  const [run, setRun] = useState<boolean>(false);
  const [stepIndex, setStepIndex] = useState<number>(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRun(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const parsedSteps = _.map(steps, (step) => ({
    ...step,
    content: ReactHtmlParser(step.content),
  }));

  const handleCallback = (data: CallBackProps) => {
    const { type, step, index, status, action } = data;
    const isLastStep = index === parsedSteps.length - 1;
    const tourEnded = type === EVENTS.TOUR_END || status === 'finished';
    const { clickable = false } = step as typeof step & { clickable?: boolean };

    if (clickable) {
      const element = document.querySelector('.react-joyride__spotlight');
      if (element) element.classList.add('show-click');
    }

    // This is the callback function that handles the Joyride events
    // forces the container to move to the above 2 steps
    if (
      [
        EVENTS.STEP_AFTER as typeof EVENTS.STEP_AFTER,
        EVENTS.TARGET_NOT_FOUND as typeof EVENTS.TARGET_NOT_FOUND,
      ].includes(type as typeof EVENTS.STEP_AFTER | typeof EVENTS.TARGET_NOT_FOUND)
    ) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }

    // smooth behaviour of the scroll to the top of the page
    if (tourEnded && isLastStep) window.scrollTo({ top: 0, behavior: 'smooth' });

    // This makes sure that the tour ends only when the last step is reached
    if (type === EVENTS.TOUR_END) createUsersDemos(id);
  };

  return (
    <div className="joyride-container">
      <Joyride
        steps={parsedSteps}
        run={run}
        scrollToFirstStep
        continuous
        hideCloseButton
        spotlightPadding={5}
        scrollOffset={100}
        disableOverlayClose
        callback={handleCallback}
        spotlightClicks
        showProgress
        showSkipButton
        styles={{
          options: {
            zIndex: 1000,
          },
        }}
        stepIndex={stepIndex}
      />
    </div>
  );
};

export default SiteTour;
